import { Directive, Input, OnInit } from '@angular/core';

import { WdxButtonSize, WdxButtonStyle } from './wdx-button.interface';

@Directive({
    selector:
        'button[wdxButton], a[wdxButton], button[wdxIconButton], a[wdxIconButton]',
    standalone: false,
    host: {
        '[class.btn]': 'true',
        '[class.btn-primary]': 'wdxButton === WdxButtonStyle.Primary',
        '[class.btn-danger]': 'wdxButton === WdxButtonStyle.Danger',
        '[class.btn-outline-primary]':
            'wdxButton === WdxButtonStyle.OutlinePrimary',
        '[class.btn-link]': 'wdxButton === WdxButtonStyle.Link',
        '[class.btn-inline]': 'wdxButton === WdxButtonStyle.Inline',
        '[class.btn-success]': 'wdxButton === WdxButtonStyle.Success',
        '[class.btn-ghost]': 'wdxButton === WdxButtonStyle.Ghost',
        '[class.btn-sm]': 'wdxButtonSize === WdxButtonSize.Sm',
        '[class.btn-lg]': 'wdxButtonSize === WdxButtonSize.Lg',
        '[class.btn-icon]': 'wdxIconButton',
        '[class.text-decoration-none]': 'wdxIconButton',
    },
})
export class WdxButtonDirective implements OnInit {
    public readonly WdxButtonStyle = WdxButtonStyle;
    public readonly WdxButtonSize = WdxButtonSize;

    /**
     * sets the button type
     */
    @Input() wdxButton: WdxButtonStyle | '' = '';

    /**
     * Specify the size of the button
     */
    @Input() wdxButtonSize: WdxButtonSize = WdxButtonSize.Normal;

    /**
     * Update styling for buttons that contain only an icon
     */
    @Input() wdxIconButton!: boolean | string;

    ngOnInit(): void {
        this.setButton();
        this.setIconButton();
    }

    setButton(): void {
        if (!this.wdxButton) {
            this.wdxButton = WdxButtonStyle.OutlinePrimary;
        }
    }

    setIconButton(): void {
        this.wdxIconButton =
            Boolean(this.wdxIconButton) || this.wdxIconButton === '';
    }
}
